// Safari < 15.4 compatibility. Manual guards: Babel strips core-js entry imports for browsers outside browserslist.
if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value: (obj, key) => Object.prototype.hasOwnProperty.call(Object(obj), key),
    writable: true,
    configurable: true,
  });
}

if (typeof Array.prototype.at !== "function") {
  const at = function at(n) {
    const len = this.length;
    let i = Math.trunc(n) || 0;
    if (i < 0) i += len;
    return i < 0 || i >= len ? undefined : this[i];
  };
  for (const proto of [Array.prototype, String.prototype]) {
    if (typeof proto.at !== "function") {
      Object.defineProperty(proto, "at", { value: at, writable: true, configurable: true });
    }
  }
}

if (typeof String.prototype.replaceAll !== "function") {
  Object.defineProperty(String.prototype, "replaceAll", {
    value: function replaceAll(search, replacement) {
      if (search instanceof RegExp) return this.replace(search, replacement);
      return this.split(search).join(replacement);
    },
    writable: true,
    configurable: true,
  });
}

if (typeof globalThis.structuredClone !== "function") {
  globalThis.structuredClone = (value) => JSON.parse(JSON.stringify(value));
}
